import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

type AppRole = 'admin' | 'moderator' | 'user';

export function useUserRole() {
  const { user } = useAuth();
  const [role, setRole] = useState<AppRole | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchRole = useCallback(async (userId: string) => {
    console.log('fetchRole called for userId:', userId);
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', userId)
        .single();

      console.log('fetchRole result:', { data, error });

      if (error) {
        console.error('Error fetching user role:', error);
        setRole('user');
      } else {
        const fetchedRole = data?.role as AppRole || 'user';
        console.log('Setting role to:', fetchedRole);
        setRole(fetchedRole);
      }
    } catch (err) {
      console.error('Error in fetchRole:', err);
      setRole('user');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!user) {
      setRole(null);
      setLoading(false);
      return;
    }

    fetchRole(user.id);
  }, [user, fetchRole]);

  const isAdmin = role === 'admin';
  const isModerator = role === 'moderator';
  const isUser = role === 'user';

  return { role, isAdmin, isModerator, isUser, loading, refetch: () => user && fetchRole(user.id) };
}
